module.exports = __webpack_public_path__ + "img/logo-makine.93f0be22.png";